import { ExtendedCodeBlock } from '../extensions';
import { lowlight } from 'lowlight/lib/core';

export function configureCodeBlock() {
  return ExtendedCodeBlock.configure({
    lowlight,
  });
}
